<template>
  <div class="joinDetail_java padding80">
    <Header :current="3"></Header>
    <div class="left">
      <div @click="left"><img src="../../assets/join/back.png" alt=""> &nbsp 返回职位列表</div>
    </div>
    <div class="content">
      <div class="cpjl">java开发工程师</div>
      <div class="xinxi">
        <div class="xinxi1"><img src="../../assets/join/local.png" alt="">&nbsp天津、杭州、台州、福州等</div>
        <div class="xinxi2"></div>
        <div class="xinxi3">全职</div>
        <div class="xinxi2"></div>
        <div class="xinxi3">本科</div>
        <div class="xinxi2"></div>
        <div class="xinxi3">若干人</div>
      </div>
      <div class="time">发布时间：2020-03-10 </div>
    </div>
    
    <div class="yq">
      <div class="title">岗位职责</div>
      <div class="thetext">1、负责公司产品功能需求、活动需求的迭代开发</div>
      <div class="thetext">2、参与业务系统重构与优化，能够合理提出架构、业务流程、性能等方面的优化建议</div>
      <div class="thetext">3、善于协调沟通，能够主动去解决开发中遇到的问题 </div>
    </div>

    <div class="yq">
      <div class="title">岗位要求</div>
      <div class="thetext">1、本科以上学历，1年以上Java后端服务开发经验，精通Java开发，熟练掌握分布式锁和分布式事务</div>
      <div class="thetext">2、熟悉Spring boot，Spring Cloud、mybatis，jpa等开源框架,掌握一种或者多种关系型数据库，如Mysql,oracle,db2 </div>
      <div class="thetext">3、熟练掌握nosql数据库一种或者多种</div>
      <div class="thetext">4、熟悉消息中间件，rabbitMq和kafka等</div>
      <div class="thetext">5、熟悉多线程,有大数据高并发相关经验</div>
    </div>

    <div class="yq">
      <div class="title">联系方式</div>
      <div class="thetext">如果您对我们感兴趣，请发送简历至我们的邮箱：<span> hr@leimon.com.cn</span></div>

    </div>

    <Footer></Footer>
  </div>
</template>

<script>
export default {
  name: "joinDetail_java",
  data() {
    return {

    };
  },
  created(){window,scrollTo(0,0)},
  mounted() {

  },
  methods: {
    left(){
      this.$router.push({name:'join'})
    }
  }
};
</script>

<style scoped lang="less">
.left{
  height: 54px;
  min-width: 900px;
  background: #FFFFFF;
  box-shadow: 0px 9px 18px 0px rgba(0, 0, 0, 0.06);
  line-height: 54px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  cursor: pointer;
  div{
    color: #666666;
    display: flex;
    width: 930px;
    margin: 0px auto;
    img{
      width: 8px;
      height: 14px;
      vertical-align: middle;
      margin-top: 20px;
    }
  }

}
.content{
    width: 900px;
    margin: 0px auto;
    background: #F7F8FA;
    padding: 20px;
    margin-top: 46px;
    font-family: PingFangSC-Semibold, PingFang SC;
    color: #141414;
    .cpjl{
      font-size: 22px;
      font-weight: bold;
    }
    .xinxi{
      margin-top: 20px;
      display: flex;
      font-family: PingFangSC-Regular, PingFang SC;
      color: #484848;
      font-size: 13px;
      .xinxi1{

        display: flex;
        img{
          width: 12px;
          height: 16px;
        }
      }
      .xinxi2{
        width: 1px;
        height: 13px;
        background: #D8D8D8;
        margin-left: 12px;
        margin-top: 3px;
      }
      .xinxi3{
        margin-left: 12px;
      }
    }
    .time{
      margin-top: 20px;
      font-size: 8px;
      font-family: PingFangSC-Regular, PingFang SC;
      color: #484848;
    }
  }
  .yq{
    width: 940px;
    margin: 0px auto;
    margin-top: 50px;
    font-family: PingFangSC-Semibold, PingFang SC;
    color: #141414;
    margin-bottom: 40px;
    .title{
      font-size: 18px;
      font-weight: bold;
      margin-bottom: 26px;
    }
    .thetext{
      font-size: 11px;
      line-height: 26px;
      span{
        font-size: 10px;
        color: #FFCF00;
      }
    }
  }
</style>
